module.exports = __webpack_public_path__ + "static/4-b924ffc7672171e1f59d7b9497f37b2f.jpeg";